<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <p-pickList [source]="lisZonaLibre" [target]="lisZonaGrupo"
                  sourceHeader="{{'GRUPOZONA.LBL_ZONASDISPONIBLES'|translate}}"
                  targetHeader="{{'GRUPOZONA.LBL_ZONASCREADAS'|translate}}"
                  [showTargetControls]="false"
                  [showSourceControls]="false"
                  filterBy="nombreZona,codigoZona">
        <ng-template let-row pTemplate="item">
          <div class="p-helper-clearfix">
            {{row.codigoZona + ' - ' + row.nombreZona}}
          </div>
        </ng-template>
      </p-pickList>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a (click)="regresar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                type="button" (click)="onSubmit()"
                pButton></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="grupoZona">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
